import React, { useMemo, useState } from "react";
import {
  Container,
  FormControl,
  FormLabel,
  Input,
  Card,
  CardBody,
  CardFooter,
  Button,
  Flex,
  Alert,
  AlertIcon,
  AlertTitle,
  Divider,
} from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "../config/axios";
import { getFullLocationUrl } from "../config";

const ChangePasswordPage = () => {
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");

  const { search } = useLocation();

  const query = useMemo(() => new URLSearchParams(search), [search]);

  const onSubmit = async () => {
    if (newPassword && newPassword === newPasswordConfirm) {
      try {
        setError(false);
        await axios.post("/user/change-password", {
          username: query.get("username"),
          password,
          newPassword,
        });
        //@ts-ignore
        window.location = getFullLocationUrl("#/login?newPassword=true");
      } catch (err) {
        console.error(err);
        setError(true);
      }
    } else {
      setError(true);
    }
  };

  return (
    <Flex bg={"blue.100"} height={"100vh"} alignItems={"center"}>
      <Container maxW="md" centerContent>
        <Card width={"100%"}>
          <CardBody>
            <FormControl isRequired>
              <FormLabel>{t("password")}</FormLabel>
              <Input
                placeholder={t("password")}
                name="password"
                type="password"
                onChange={({ target }) => setPassword(target.value)}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>{t("newPassword")}</FormLabel>
              <Input
                placeholder={t("password")}
                name="newPassword"
                type="password"
                onChange={({ target }) => setNewPassword(target.value)}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>{t("newPasswordConfirm")}</FormLabel>
              <Input
                placeholder={t("password")}
                name="newPasswordConfirm"
                type="password"
                onChange={({ target }) => setNewPasswordConfirm(target.value)}
              />
            </FormControl>
            {error && (
              <Alert status="error" marginTop={4}>
                <AlertIcon />
                <AlertTitle>{t("changePasswordError")}</AlertTitle>
              </Alert>
            )}
          </CardBody>

          <Divider />
          <CardFooter>
            <Flex
              justifyContent={"space-between"}
              alignItems="center"
              width={"100%"}
            >
              <Button colorScheme="blue" onClick={onSubmit}>
                {t("changePassword")}
              </Button>
            </Flex>
          </CardFooter>
        </Card>
      </Container>
    </Flex>
  );
};

export default ChangePasswordPage;
